'use strict';


export default class EmailDialogModel {
  static getModel(prop) {
      if(prop) {
        return model[prop];
      }
      return model;
  }
  
}

const model = {
    EmailTemplates :{
        required :{
            message :'This field is required.'
        }
    },
    CCEmployees :{},
    CCCompany :{}
};




// WEBPACK FOOTER //
// ./shared/react/admin/Emails/model.js